import { ProfessionalConnectionsFields } from 'src/non-financial-data/v2/sections/fields/ProfessionalConnectionsFields';
import IndividualEntityForm from '../IndividualEntityForm';

export default function ProfessionalConnectionsV2() {
  return (
    <IndividualEntityForm title="Key contacts">
      <ProfessionalConnectionsFields />
    </IndividualEntityForm>
  );
}
